import Vue from "vue";
import TurbolinksAdapter from "vue-turbolinks";

import QuestionsAnswers from "./index.vue";

document.addEventListener("turbolinks:load", () => {
  const el = document.getElementById("questions-answers");
  if (el) {
    const props = JSON.parse(el.getAttribute("data"));
    new Vue({
      el,
      mixins: [TurbolinksAdapter],
      render: (h) => h(QuestionsAnswers, { props }),
    });
  }
});



// WEBPACK FOOTER //
// ./app/javascript/packs/questions/answers/index.js